export default __webpack_public_path__ + "static/media/edition-jw-1.49db133c.jpg";